/* Napuplant — el gesto de «atrás» cierra la capa abierta, en vez de salir de la página.

   EL COMPORTAMIENTO DE PARTIDA NO ERA UN FALLO, era el navegador haciendo lo
   suyo. El cajón del carrito y el menú son capas superpuestas: abrirlos no
   navega a ningún sitio, así que no dejan entrada en el historial. Si el
   cliente venía del catálogo, entraba en una planta y abría el carrito, el
   gesto de atrás lo devolvía al catálogo — perdía la ficha en la que estaba.

   En móvil eso escuece: atrás es un gesto del sistema que se usa
   constantemente, y con una capa abierta lo natural es que la cierre. Y si
   además quería salir de verdad al catálogo, le cuesta dos gestos en vez de uno.

   CÓMO FUNCIONA. Al abrirse una capa se empuja una entrada de historial vacía.
   El gesto de atrás la consume, se cierra la capa y el cliente sigue en su
   ficha. Si la capa se cierra por las vías normales (el aspa, tocar fuera), se
   retira esa entrada para no dejar historial basura que obligue a pulsar atrás
   dos veces para salir de la página.

   NO SE REPLICA EL CIERRE: se pulsa el botón de cerrar que ya tiene el tema, así
   que corre su propia lógica (clases del body, foco, etc.) y no hay dos formas
   distintas de cerrar el mismo cajón que puedan separarse con el tiempo.

   Solo por debajo de 990px. En escritorio el gesto de atrás no es un gesto: es
   un botón que se pulsa a conciencia para cambiar de página, y secuestrarlo ahí
   sorprendería más que ayudaría.
*/
(function () {
  'use strict';

  var MOVIL = '(max-width: 989px)';

  /* Cada capa: cómo saber si está abierta y cómo pedirle al tema que la cierre. */
  var CAPAS = [
    {
      abierta: function () {
        var el = document.getElementById('minicart');
        return !!(el && el.classList.contains('active'));
      },
      cerrar: function () {
        /* El aspa de la cabecera del cajón. Se acota a la cabecera porque dentro
           del cajón hay más .close-btn (la nota del pedido, el bloque de
           recomendados) que cierran otras cosas. */
        var b = document.querySelector('#minicart .side-drawer-modal-head [data-sidedrawer-close]');
        if (b) b.click();
      }
    },
    {
      abierta: function () {
        return !!document.querySelector('.napu-mobile.is-open');
      },
      cerrar: function () {
        var b = document.querySelector('.napu-mobile.is-open [data-napu-menu-close]');
        if (b) b.click();
      }
    }
  ];

  var empujado = false;        // hay una entrada nuestra en el historial
  var volviendoNosotros = false;   // hemos llamado a history.back(); ignorar ese popstate
  var cerrandoPorHistoria = false; // cerramos por el gesto atrás; no llamar a back()

  function algunaAbierta() {
    for (var i = 0; i < CAPAS.length; i++) if (CAPAS[i].abierta()) return true;
    return false;
  }

  function cerrarTodas() {
    CAPAS.forEach(function (c) { if (c.abierta()) c.cerrar(); });
  }

  function revisar() {
    if (!window.matchMedia(MOVIL).matches) return;
    var abierta = algunaAbierta();

    if (abierta && !empujado) {
      empujado = true;
      try { history.pushState({ napuCapa: true }, ''); } catch (e) { empujado = false; }
      return;
    }

    if (!abierta && empujado && !cerrandoPorHistoria) {
      /* La capa se cerró por el aspa o tocando fuera. Retiramos nuestra entrada
         para que el historial quede como estaba: si no, el cliente tendría que
         pulsar atrás dos veces para salir de la ficha y parecería que la web se
         resiste a dejarle marchar. */
      empujado = false;
      volviendoNosotros = true;
      try { history.back(); } catch (e) { volviendoNosotros = false; }
    }
  }

  window.addEventListener('popstate', function () {
    if (volviendoNosotros) { volviendoNosotros = false; return; }
    if (!algunaAbierta()) { empujado = false; return; }

    /* Gesto de atrás con una capa abierta: se cierra y el cliente se queda donde
       estaba. Nuestra entrada ya la ha consumido el navegador. */
    empujado = false;
    cerrandoPorHistoria = true;
    cerrarTodas();
    setTimeout(function () { cerrandoPorHistoria = false; }, 0);
  });

  /* Se vigila el atributo class de los contenedores: es lo que el tema cambia al
     abrir y cerrar (#minicart gana 'active', el menú gana 'is-open'). No hay
     ningún evento que avise, de ahí el observador. */
  function vigilar() {
    var obs = new MutationObserver(function () { revisar(); });
    var mc = document.getElementById('minicart');
    if (mc) obs.observe(mc, { attributes: true, attributeFilter: ['class'] });
    var men = document.querySelector('.napu-mobile');
    if (men) obs.observe(men, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigilar);
  } else {
    vigilar();
  }
})();
